import { Pipe, PipeTransform } from '@angular/core';
import { OAuthProvider, OAuthProviderService } from '@platform-frontend/account';

@Pipe({
  name: 'oAuthProvider'
})
export class OAuthProviderPipe implements PipeTransform {
  constructor(private oAuthProviderService: OAuthProviderService) {}

  transform(provider: OAuthProvider | null): string {
    return this.oAuthProviderService.formatProvider(provider);
  }
}
